/* eslint-disable jsx-a11y/anchor-is-valid */
import { useMemo } from 'react';
import { Empty } from 'antd';
import { ReactComponent as ArrowLeft } from 'assets/icons/ArrowLeft.svg';
import {
  mapPayloadToSections,
  mapPayloadToSectionsFundingPrograms,
} from './utils/mappers';
import ProgramSection from './components/ProgramSection/ProgramSection';
import { PaginationFunding } from '../PaginationFunding';
import styles from './FundingPrograms.module.scss';

export function FundingPrograms({
  response,
  handleViewAll,
  handleGoBack,
  loading,
  isEmpty,
  sectionTitle,
  page,
  pageSize,
  onPaginationChange,
}) {
  const sections = useMemo(
    () =>
      response?.fundingPrograms
        ? mapPayloadToSectionsFundingPrograms(response || {})
        : mapPayloadToSections(response || {}),
    [response]
  );

  const handlePaginationChange = (newPage, newPageSize) => {
    if (onPaginationChange) {
      onPaginationChange(newPage, newPageSize);
    }
  };

  return (
    <div>
      {sectionTitle && !isEmpty && (
        <div className={styles['funding-program-paginated-header']}>
          <div className={styles['']}>
            <ArrowLeft />
            <a
              href="#"
              className={styles['funding-program-paginated-header-link']}
              onClick={e => {
                e.preventDefault();
                handleGoBack?.();
              }}
              role="button"
            >
              Πίσω στην My Funding
            </a>
          </div>
          <div className={styles['pagination-wrapper']}>
            <PaginationFunding
              page={page}
              pageSize={pageSize}
              total={response?.totalElements ?? 0}
              onChange={handlePaginationChange}
            />
          </div>
        </div>
      )}
      {isEmpty === true ? (
        <div className={styles['empty-section-container']}>
          <Empty description="Δεν υπάρχουν διαθέσιμα προγράμματα" />
        </div>
      ) : (
        sections.map(sec => (
          <ProgramSection
            key={sec.key}
            title={sec.title}
            programs={sec.programs}
            loading={loading}
            onViewAll={title => handleViewAll(title)}
            viewAllLabel="Δες τα όλα"
            sectionTitle={sectionTitle}
            response={response}
          />
        ))
      )}
      {sectionTitle && !isEmpty && (
        <div className={styles['pagination-wrapper-footer']}>
          <PaginationFunding
            page={page}
            pageSize={pageSize}
            total={response?.totalElements ?? 0}
            onChange={handlePaginationChange}
          />
        </div>
      )}
    </div>
  );
}
